"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = _interopRequireDefault(require("../icons"));

var _Input = _interopRequireDefault(require("./Input"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Number =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Number, _PureComponent);

  function Number(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleAddClick = _this.handleCalc.bind(_assertThisInitialized(_assertThisInitialized(_this)), props.step);
    _this.handleSubClick = _this.handleCalc.bind(_assertThisInitialized(_assertThisInitialized(_this)), -props.step);
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Number.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hold = false;
    if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
  };

  _proto.handleChange = function handleChange(value, check, isEmpty) {
    if (isEmpty) {
      this.props.onChange(value);
      return;
    }

    if (!check) {
      if (new RegExp('^-?\\d*\\.?\\d*$').test(value)) {
        this.props.onChange(value);
      }

      return;
    }

    if (typeof this.props.digits === 'number') {
      value = parseFloat(value.toFixed(this.props.digits));
    } else {
      var stepStr = this.props.step.toString();
      var dot = stepStr.lastIndexOf('.');
      if (dot >= 0) value = parseFloat(value.toFixed(stepStr.length - dot));
    }

    var _this$props = this.props,
        min = _this$props.min,
        max = _this$props.max;
    if (max !== undefined && value > max) value = max;
    if (min !== undefined && value < min) value = min;

    if (value !== this.props.value) {
      this.props.onChange(value);
    }
  };

  _proto.handleBlur = function handleBlur(e) {
    var value = parseFloat(e.target.value); // for the empty

    if (e.target.value === '' && this.props.allowNull) {
      value = null;
    } // eslint-disable-next-line no-restricted-globals


    if (isNaN(value)) value = 0;
    this.handleChange(value, true, value === null);
    this.props.onBlur(e);
  };

  _proto.changeValue = function changeValue(mod) {
    if (this.props.disabled) return;
    var value = parseFloat(this.props.value); // eslint-disable-next-line

    if (isNaN(value)) value = 0;
    this.handleChange(value + mod, true);
  };

  _proto.longPress = function longPress(mod) {
    var _this2 = this;

    if (!this.hold) return;
    setTimeout(function () {
      _this2.changeValue(mod);

      _this2.longPress(mod);
    }, 50);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var _this3 = this;

    var step = this.props.step;
    this.hold = true;
    if (e.keyCode !== 38 && e.keyCode !== 40) return;
    e.preventDefault();
    var mod = e.keyCode === 38 ? step : -step;
    this.changeValue(mod);
    if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
    this.keyPressTimeOut = setTimeout(function () {
      _this3.longPress(mod);
    }, 600);
  };

  _proto.handleCalc = function handleCalc(mod) {
    var _this4 = this;

    this.hold = true;
    this.changeValue(mod);
    this.keyPressTimeOut = setTimeout(function () {
      _this4.longPress(mod);
    }, 1000);
  };

  _proto.handleKeyUp = function handleKeyUp() {
    this.hold = false;
    if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
  };

  _proto.handleMouseUp = function handleMouseUp() {
    this.hold = false;
    if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        allowNull = _this$props2.allowNull,
        other = _objectWithoutPropertiesLoose(_this$props2, ["onChange", "allowNull"]);

    return [_react.default.createElement(_Input.default, _extends({
      key: "input"
    }, other, {
      className: (0, _styles.inputClass)('number'),
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      onBlur: this.handleBlur,
      type: "number"
    })), _react.default.createElement("a", {
      key: "up" // do not need the tab to focus
      ,
      tabIndex: -1,
      className: (0, _styles.inputClass)('number-up'),
      href: "javascript:;",
      onMouseDown: this.handleAddClick,
      onMouseUp: this.handleMouseUp,
      onMouseLeave: this.handleMouseUp
    }, _icons.default.AngleRight), _react.default.createElement("a", {
      key: "down" // do not need the tab to focus
      ,
      tabIndex: -1,
      className: (0, _styles.inputClass)('number-down'),
      href: "javascript:;",
      onMouseDown: this.handleSubClick,
      onMouseUp: this.handleMouseUp,
      onMouseLeave: this.handleMouseUp
    }, _icons.default.AngleRight)];
  };

  return Number;
}(_react.PureComponent);

Number.propTypes = {
  disabled: _propTypes.default.bool,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  onBlur: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  step: _propTypes.default.number,
  digits: _propTypes.default.number,
  allowNull: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
Number.defaultProps = {
  step: 1,
  allowNull: false
};
var _default = Number;
exports.default = _default;